import { reactive } from 'vue';

export const actionsStore = reactive({
  selectedRows: [],
  updateTable: false,
})
